import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { CodyIconBadge } from '../components/CodyLogo';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';

export default function OpsLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      if (data.user?.role !== 'admin') {
        toast.error('Admin access only');
        return;
      }
      toast.success('Welcome back');
      navigate('/ops');
    } catch (err) {
      toast.error(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 rounded-2xl bg-white shadow-[0_4px_40px_rgba(0,0,0,0.15)] border-0">
        <div className="flex items-center justify-center gap-2 mb-8">
          <CodyIconBadge size={44} />
          <div className="ml-1">
            <span className="text-lg font-bold block" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Ops Panel</span>
            <span className="text-[10px] text-[#9ca3af] flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> Admin Access</span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-[#0B0F17] mb-1.5 block">Email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@company.com" required className="h-11 rounded-lg" data-testid="ops-login-email" />
          </div>
          <div>
            <label className="text-sm font-medium text-[#0B0F17] mb-1.5 block">Password</label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" required className="h-11 rounded-lg" data-testid="ops-login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 rounded-lg font-semibold text-sm bg-[#0B0F17] hover:bg-[#1a1f2e] text-white" data-testid="ops-login-submit">
            {loading ? 'Authenticating...' : 'Sign In to Ops'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
